import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import React, { memo, useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { metodoPrograma } from '../../components/api'
import AutoComplete from '../../components/AutoComplete/AutoComplete'
import { GlobalContext } from '../../App'
import { setWarning } from '../../components/alerts'
import dayjs from 'dayjs'
import DateField from '../../components/DateField/DateField'

const retornaUsuario = (u = []) => ({
  idUsuario: u[0] || undefined,
  dsEmail: u[2] || '',
  dsNome: u[3] || '',
  dtExclusao: u[5] || '',
  dtInclusao: u[4] || '',
  nrDocumento: u[8] || '',
  dtNascimento: u[9] ? dayjs(u[9], 'YYYY-MM-DD') : null,
  dsSenha: '',
  dsSenhaConfirmacao: '',
})

const Edicao = ({ contratante, idTipoUsuario, usuarioAberto, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [acAgenda, setAcAgenda] = useState(usuarioAberto?.[6] || [])
  const [acCentroCusto, setAcCentroCusto] = useState(usuarioAberto?.[10] || [])

  const { control, register, handleSubmit } = useForm({
    defaultValues: retornaUsuario(usuarioAberto),
  })

  const salva = async (values) => {
    if (values.dsSenha !== values.dsSenhaConfirmacao) {
      setWarning('As senhas não conferem')
      return
    }
    const dados = {
      ...values,
      idLocalAtendimento: localAtendimento[0],
      dtNascimento: values.dtNascimento
        ? dayjs(values.dtNascimento).format('YYYY-MM-DD HH:MM:ss')
        : null,
      idContratante: contratante[0],
      idTipoUsuario,
      agendas: acAgenda?.map((item) => item?.[0]?.[0]),
      centrosCusto: acCentroCusto.flatMap((item) => item[0]),
    }
    const res = await metodoPrograma('salva', dados)
    if (res.status) voltar()
  }
  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextField
            {...register('dsNome')}
            name="dsNome"
            label="Nome"
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextField
            {...register('dsEmail')}
            name="dsEmail"
            label="Email"
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <TextField
            {...register('dtInclusao')}
            name="dtInclusao"
            label="Inclusão"
            disabled
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <TextField
            {...register('dtExclusao')}
            name="dtExclusao"
            label="Exclusão"
            disabled
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <TextField
            {...register('dsSenha')}
            type="password"
            name="dsSenha"
            label="Senha"
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
          <TextField
            {...register('dsSenhaConfirmacao')}
            type="password"
            name="dsSenhaConfirmacao"
            label="Confirmação de senha"
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <TextField
            {...register('nrDocumento')}
            name="nrDocumento"
            label="Documento (CPF, RG ou CNH)"
            fullWidth
            InputLabelProps={{ shrink: true }}
            size="small"
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Controller
            {...register('dtNascimento')}
            name="dtNascimento"
            control={control}
            InputLabelProps={{ shrink: true }}
            render={({ field, fieldState }) => (
              <DateField
                {...field}
                label="Data de Nascimento"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={field.value || null}
                onChange={(v) => field.onChange(v)}
                slotProps={{
                  textField: {
                    error: Boolean(fieldState.error),
                    helperText: fieldState.error?.message,
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <AutoComplete
            multiple
            InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            label="Agendas do Usuário"
            metodo="buscaAgenda"
            value={acAgenda}
            size="small"
            onChange={(_, val) => setAcAgenda(val)}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <AutoComplete
            multiple
            InputLabelProps={{ shrink: true }}
            filterSelectedOptions
            label="Centro de Custo"
            metodo="buscaCentroCusto"
            value={acCentroCusto}
            size="small"
            onChange={(_, val) => setAcCentroCusto(val)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
